import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'app-drawer',
  imports: [CommonModule, MatIconModule],
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
})
export class DrawerComponent {
  @Input() open = false;
  @Input() title = '';
  @Input() subtitle = '';
  @Input() width = '440px';
  @Input() footer = true;
  @Output() closed = new EventEmitter<void>();

  onClose(): void { this.closed.emit(); }

  @HostListener('document:keydown.escape')
  onEsc(): void { if (this.open) this.onClose(); }
}
